import { useField } from "formik";
import { cn } from "utils/helpers";
import { FieldForm } from "components/RFQ/Input";
import { BidderQuestionnaireHeader } from "./BidderQuestionnaireHeader";
import { useOptions } from "../hooks/useOptions";

export const DropdownQuestionnaire = ({
	className,
	question,
	options,
	required,
	fieldValue,
	isClientPreview = false,
	previewQuestion = null,
	...props
}) => {
	const [, { error }] = useField(props);

	const dropDownOptions = useOptions({
		isClientPreview,
		fieldValue,
		previewQuestion,
	});

	return (
		<div className={cn(className)}>
			<BidderQuestionnaireHeader
				question={question}
				required={required}
				error={error}
				touchedField={props?.touchedField}
				description={
					props?.rfqSubmission ? "Select one option from dropdown" : null
				}
			/>
			<div>
				<FieldForm
					type="select"
					options={dropDownOptions}
					className="my-4 w-full"
					required={required}
					name={props.name}
					disabled={props?.disabled && !isClientPreview}
				/>
			</div>
		</div>
	);
};
